/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { getShouldRenderPersonalCommentsDropin } from "selectors/overlayDropinSelectors";
import { isFirefox } from "dc-preview-utils/src/Utils/UserAgentUtils";
import { getFeatureFlagApis } from "../publicApis/featureFlag";

export const isPersonalCommentingEnabled = stores => getShouldRenderPersonalCommentsDropin(stores);

export const shouldEnableProgressiverendering = () => window.OffscreenCanvas && !isFirefox();

export const enableToolsInMultidoc = () => getFeatureFlagApis().getFeatureFlag("enable-tools-multidoc");
